type ThreeModule = Pick<typeof import('three'), 'BoxGeometry'>;

export type ProformFillingDimensions = {
  heightMm: number;
  widthMm: number;
};

export const PROFORM_FILLING_GEOMETRY_DEPTH_MM = 0.5;

export function createProformFillingGeometry(
  THREE: ThreeModule,
  dimensions: ProformFillingDimensions,
) {
  return new THREE.BoxGeometry(
    dimensions.widthMm * 0.72,
    dimensions.heightMm * 0.92,
    PROFORM_FILLING_GEOMETRY_DEPTH_MM,
  );
}
